module.exports = __webpack_public_path__ + "static/GreenAmerica-logo-Color-82656a548d635b2869cc02929e3238da.png";